/** Cause-area images in public/ProjectImages */
export const SECTOR_IMAGES = {
  madness: 'madness.jpg',
  disability: 'disability.jpg',
  funerals: 'funerals.jpg',
  mosquesMadrasas: 'mosque.jpg',
  waterWells: 'water.webp',
  food: 'food.webp',
};

export function getSectorImageUrl(sectorId) {
  const file = SECTOR_IMAGES[sectorId];
  if (!file) return null;
  return `${process.env.PUBLIC_URL}/ProjectImages/${file}`;
}
